export default __webpack_public_path__ + "static/media/MJMB.66f6ce3b.png";